import { cn } from "@/libs/utils";
import { IconBaseType } from "@/v2-components/core/icon/type";

export default function HorizontalViewIcon({ className }: IconBaseType) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
    >
      <path
        d="M5.42834 12.8235C5.03888 12.8235 4.70346 12.6812 4.42208 12.3967C4.14069 12.1122 4 11.7731 4 11.3792V5.44427C4 5.05047 4.14069 4.7113 4.42208 4.42678C4.70346 4.14226 5.03888 4 5.42834 4H18.5717C18.9611 4 19.2965 4.14226 19.578 4.42678C19.8594 4.7113 20 5.05047 20 5.44427V11.3792C20 11.7731 19.8594 12.1122 19.578 12.3967C19.2965 12.6812 18.9611 12.8235 18.5717 12.8235H5.42834ZM5.42834 11.3792H18.5717V5.44427H5.42834V11.3792Z"
        fill="currentColor"
      />
      <path
        d="M19.3583 15.2532H4.6273C4.28086 15.2532 4.00002 15.5372 4.00002 15.8875C4.00002 16.2378 4.28086 16.5217 4.6273 16.5217H19.3583C19.7047 16.5217 19.9856 16.2378 19.9856 15.8875C19.9856 15.5372 19.7047 15.2532 19.3583 15.2532Z"
        fill="currentColor"
      />
      <path
        d="M19.3583 18.7315H4.6273C4.28086 18.7315 4.00002 19.0154 4.00002 19.3657C4.00002 19.716 4.28086 20 4.6273 20H19.3583C19.7047 20 19.9856 19.716 19.9856 19.3657C19.9856 19.0154 19.7047 18.7315 19.3583 18.7315Z"
        fill="currentColor"
      />
    </svg>
  );
}
